import _ from 'lodash'
import { MeshContainerLayout, MeshItemLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types/dist'

type ComponentLayoutRetriever = (item: SingleLayoutData) => number

export const top: ComponentLayoutRetriever = (layoutData) => (layoutData.itemLayout as MeshItemLayout).absoluteRect.top

export const left: ComponentLayoutRetriever = (layoutData) =>
	(layoutData.itemLayout as MeshItemLayout).absoluteRect.left

export const height: ComponentLayoutRetriever = (layoutData) =>
	(layoutData.itemLayout as MeshItemLayout).absoluteRect.height
export const bottom: ComponentLayoutRetriever = (layoutData) => top(layoutData) + height(layoutData)
export const fitToContentHeight = (layoutData: SingleLayoutData) =>
	(layoutData.containerLayout as MeshContainerLayout)?.containerHeight === 'auto'
export const getContainerHeight = (layoutData: SingleLayoutData): number =>
	(layoutData.containerLayout as MeshContainerLayout)?.containerHeight as number
export const isRotated = (layoutData: SingleLayoutData) =>
	_.isNumber((layoutData.itemLayout as MeshItemLayout).absoluteRect.rotationInDegrees) &&
	(layoutData.itemLayout as MeshItemLayout).absoluteRect.rotationInDegrees !== 0
